import React, { Component } from "react";
import workImg1 from "../images/ozenMain.jpg";
import workImg2 from "../images/metlife.png";
import workImg3 from "../images/synctree.png";
import workImg4 from "../images/BackOffice.png";

import Freelancer from "../components/Freelance_Banner/Freelancer";
export default class Projects extends Component {
  render() {
    return (
      <>
        <section className="ftco-section ftco-project" id="projects-section">
          <div className="container-fluid px-md-0">
            <div className="row no-gutters justify-content-center pb-5">
              <div className="col-md-12 heading-section text-center ftco-animate">
                <h1 className="big big-2">Projects</h1>
                <h2 className="mb-4">Projects</h2>
                <p>Introduce projects I have done so far</p>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-md-4" style={{ padding: "7px" }}>
                <a
                  href="https://tongil-mern-backoffice-prac.vercel.app/dashboard"
                  target="_blank"
                >
                  <div
                    className="project img ftco-animate d-flex justify-content-center align-items-center"
                    style={{
                      backgroundImage: `url(${workImg4})`,
                      backgroundSize: "contain",
                    }}
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-1">
                      <h3 style={{ fontSize: "32px", fontFamily: "bold" }}>
                        BackOffice Project
                      </h3>
                      <span style={{ color: "black" }}>Mern Stack Project</span>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-md-4" style={{ padding: "7px" }}>
                <a href="https://ozen-main.netlify.app/" target="_blank">
                  <div
                    className="project img ftco-animate d-flex justify-content-center align-items-center"
                    style={{
                      backgroundImage: `url(${workImg1})`,
                      backgroundSize: "contain",
                    }}
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-1">
                      <h3 style={{ fontSize: "32px", fontFamily: "bold" }}>
                        Restaurant Website
                      </h3>
                      <span style={{ color: "black" }}>React Project</span>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-md-4" style={{ padding: "7px" }}>
                <a href="https://cyber.metlife.co.kr/#" target="_blank">
                  <div
                    className="project img ftco-animate d-flex justify-content-center align-items-center"
                    style={{
                      backgroundImage: `url(${workImg2})`,
                      backgroundSize: "contain",
                    }}
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-1">
                      <h3 style={{ fontSize: "32px", fontFamily: "bold" }}>
                        Metlife One PPX
                      </h3>
                      <span style={{ color: "black" }}>React Project</span>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-md-4" style={{ padding: "7px" }}>
                <a href="https://synctreestudio.com/#/apps" target="_blank">
                  <div
                    className="project img ftco-animate d-flex justify-content-center align-items-center"
                    style={{
                      backgroundImage: `url(${workImg3})`,
                      backgroundSize: "contain",
                    }}
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-1">
                      <h3 style={{ fontSize: "32px", fontFamily: "bold" }}>
                        SyncTree Studio
                      </h3>
                      <span style={{ color: "black" }}>React Project</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <Freelancer />
      </>
    );
  }
}
